import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';

const PrivacyPolicy: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#FFF5F5', py: 4 }}>
      <Container maxWidth="md">
        <Paper elevation={0} sx={{ p: 4, bgcolor: 'white', borderRadius: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: '#363636' }}>
            Privacy Policy
          </Typography>
          
          <Typography variant="body2" color="text.secondary" paragraph>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            Introduction
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Tenaba, Inc. ("we," "our," or "us") operates the WTG!  platform. This Privacy Policy explains how we collect, 
            use, disclose, and safeguard your information when you use our service.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            Information We Collect
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            We collect information that you provide directly to us, including:
          </Typography>
          
          <Typography component="ul" sx={{ pl: 4, lineHeight: 1.8 }}>
            <li>City and location preferences for tour generation</li>
            <li>Duration and theme preferences</li>
            <li>Questions and feedback about locations</li>
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            How We Use Your Information
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            We use the collected information to:
          </Typography>
          
          <Typography component="ul" sx={{ pl: 4, lineHeight: 1.8 }}>
            <li>Generate personalized walking tours</li>
            <li>Improve our service and user experience</li>
            <li>Respond to your questions and feedback</li>
            <li>Ensure the security and integrity of our platform</li>
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            Contact Us
          </Typography>
          
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            If you have any questions about this Privacy Policy, please contact us at{' '}
            <a href="mailto:bmorioka@tenaba.com" style={{ color: '#4ECDC4', textDecoration: 'none' }}>
              bmorioka@tenaba.com
            </a>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy; 